import { useTranslation } from 'react-i18next'
import { Link, useLocation, useParams } from 'react-router-dom'

export default function TopHeader() {
  const { lng } = useParams()
  const { t } = useTranslation()
  const location = useLocation()

  // Determine if the current path is the home page
  const isHome = location.pathname.includes(['/home'])
  return (
    <div className="m-auto mx-auto flex w-full flex-row-reverse justify-between px-8 py-2 lg:max-w-[1000px] lg:px-0 xl:max-w-[1200px]">
      <div>
        <Link
          to={'https://aidsmo.org/'}
          target="_blank"
        >
          <img
            className="!h-16 !w-16"
            title="المنظمة العربية للتنمية الصناعية والتقييس والتعدين"
            src="/assets/logos/aidsmo_logo.webp"
            alt="aidsmo_logo"
          />
        </Link>
      </div>
      <div>
        <div className="flex items-center gap-2">
          <Link to={`/${lng}/home`}>
            <img
              className="!h-16 !w-16"
              title=""
              src="/assets/logos/app_logo.svg"
              alt="aidsmo_logo"
            />
          </Link>
          <h1 className={`text-xl font-bold ${isHome ? 'text-white' : 'text-primary-600'} hidden px-4 md:block`}>{t('PLATFORM_NAME')}</h1>
        </div>
      </div>
    </div>
  )
}
